<template>
  <!-- 巡查记录 -->
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box" style="width:10%">
        <el-dropdown>
            <el-button type="primary" plain size="mini" icon="el-icon-top-right">
              导出
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-link type="primary" @click="exportPatrolTaskDetails"
                  >巡查任务详情</el-link
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <el-link type="primary" @click="exportPatrolUserLog"
                  >人员完成情况</el-link
                >
              </el-dropdown-item>
              <!-- <el-dropdown-item>
                <el-link type="primary" @click="exportTaskDetails"
                  >时段巡查任务详情</el-link
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <el-link type="primary" @click="exportUserLog"
                  >时段人员完成情况</el-link
                >
              </el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
      </div>
      <div class="search_box" style="width:90%">
        <el-date-picker
        style="width:400px"
            v-model="selectDate"
            type="datetimerange"
            size="mini"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            @change="selDate"
            align="right"
          >
          </el-date-picker>
          <el-cascader
            :options="departmentHead"
            v-model="testUserInfo.userId"
            @change="selectDepartmentHead"
            ref="departmentHeadSelect"
            size="mini"
            filterable
            clearable
            placeholder="请选择巡查人"
          >
            <template slot-scope="{ node, data }">
              <span>{{ data.label }}</span>
              <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
            </template>
          </el-cascader>
          <!-- <el-cascader
            :options="departmentHead"
            v-model="testUserInfo1.userId"
            @change="selectDepartmentHead1"
            ref="departmentHeadSelect1"
            size="mini"
            filterable
            clearable
            placeholder="请选择实际巡查人"
          >
            <template slot-scope="{ node, data }">
              <span>{{ data.label }}</span>
              <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
            </template>
          </el-cascader> -->
          <el-select
            v-model="requestParam.regionalPatrolId"
            placeholder="请选择巡查区域"
            size="mini"
            clearable
          >
            <el-option
              v-for="(item, index) in allRegion"
              :key="index"
              :label="item.regionalPatrolSite"
              :value="item.regionalPatrolId"
            >
            </el-option>
          </el-select>
          <!-- <el-select
            v-model="requestParam.dailyTaskId"
            placeholder="请选择巡查任务"
            size="mini"
            clearable
          >
            <el-option
              v-for="(item, index) in allTask"
              :key="index"
              :label="item.dailyTaskName"
              :value="item.dailyTaskId"
            >
            </el-option>
          </el-select> -->
          <el-select
            v-model="requestParam.supervisorsStatus"
            placeholder="请选择巡查状态"
            size="mini"
            clearable
          >
            <el-option
              v-for="item in $store.state.select.patrolState"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-button
            class="select-btn"
            type="primary"
            plain
            icon="el-icon-search"
            size="mini"
            @click="dailyPatrolRecordSearch"
            >搜索</el-button
          >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="dailyPatrolRecordList.list"
          v-loading="tableLoading"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              {{
                requestParam.pageSize * (requestParam.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="regionalPatrol.regionalPatrolSite"
            label="巡查区域" align="center" show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="operater" label="负责人" align="center" width="120"> </el-table-column>
          <el-table-column label="巡查人" align="center" width="120">
            <template v-slot="scope">
              <div
                :class="{
                  special: scope.row.user.userName == scope.row.actualer
                }"
              >
                {{ scope.row.user.userName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="actualer" label="实际巡查人" width="120" align="center">
          </el-table-column>
          <el-table-column
            prop="startPatrolTime"
            label="计划巡查开始时间"
            width="150" align="center"
          >
            <template slot-scope="rowData">
              {{ $Common.dateFormatDateTwo(rowData.row.startPatrolTime) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="endPatrolTime"
            label="计划巡查结束时间"
            width="150" align="center"
          >
            <template slot-scope="rowData">
              {{ $Common.dateFormatDateTwo(rowData.row.endPatrolTime) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="actualPatrolTime"
            label="实际巡查时间"
            width="150" align="center"
          >
            <template slot-scope="rowData">
              <span v-if="rowData.row.actualPatrolTime <= 0">暂未巡查</span>
              <span v-if="rowData.row.actualPatrolTime > 0">
                {{ $Common.dateFormatDateTwo(rowData.row.actualPatrolTime) }}
              </span>
            </template>
          </el-table-column>

          

          <el-table-column prop="supervisorsStatus" label="巡查状态" width="80" align="center">
            <template slot-scope="scope">
              {{ $store.state.select.patrolState[scope.row.supervisorsStatus].name }}
            </template>
          </el-table-column>

          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-link
                class="link_box"
                type="primary"
                @click="getDailyPatrolRecordDetails(scope.row.id)"
                :underline="false"
                >详情</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div
        class="pagination_box"
      >
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestParam.pageNum"
          :page-size="requestParam.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="dailyPatrolRecordList.total"
        >
        </el-pagination>
      </div>

      <!-- 巡查记录详情 -->
      <el-dialog
        :before-close="cancelForm"
        :visible.sync="dialog"
        direction="ltr"
        custom-class="demo-drawer"
        ref="drawer"
        append-to-body

        size="30%"
        :wrapperClosable="false"
        title="详情"
        :close-on-press-escape="false"
          width="800px"
         class="patrolDialog"
      >
        <div class="demo-drawer__content ">
          <form class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-2 control-label">巡查地点</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="dailyPatrolRecordDetails.regionalPatrolSite"
                  disabled
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">巡查人</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="dailyPatrolRecordDetails.userName"
                  disabled
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">计划巡查开始时间</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="dailyPatrolRecordDetails.startPatrolTime"
                  disabled
                />
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">计划巡查结束时间</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="dailyPatrolRecordDetails.endPatrolTime"
                  disabled
                />
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">实际巡查时间</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="dailyPatrolRecordDetails.actualPatrolTime"
                  disabled
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">巡查状态</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="
                    $store.state.select.patrolState[
                      dailyPatrolRecordDetails.supervisorsStatus
                    ].name
                  "
                  disabled
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">检查项状态</label>
              <div class="col-sm-10">
                <span
                  v-for="(value,
                  key) in dailyPatrolRecordDetails.patrolRecordChecksList"
                  :key="key"
                >
                  <div v-if="value.status == 0" class="statusBoxDanger">异常
                    {{ value.routineInspection.content }}
                  </div>
                  <div v-if="value.status == 1" class="statusBox">正常
                    {{ value.routineInspection.content }}
                  </div>
                  <br />
                </span>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">拍照留存</label>
              <div class="col-sm-10">
                <el-image
                  v-if="dailyPatrolRecordDetails.takePhotosRetained"
                  :src="this.$store.state.config.fileUrl + dailyPatrolRecordDetails.takePhotosRetained"
                  style="width:100px;"
                  :preview-src-list="[this.$store.state.config.fileUrl + dailyPatrolRecordDetails.takePhotosRetained]"
                >
                </el-image>
                <div v-else style="height:32px;line-height: 32px;">暂无图片</div>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">巡查定位地点</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="dailyPatrolRecordDetails.searchPositioning"
                  disabled
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">巡查备注</label>
              <div class="col-sm-10">
                <textarea
                  class="form-control"
                  v-model="dailyPatrolRecordDetails.patrolNote"
                  rows="3"
                  disabled
                ></textarea>
              </div>
            </div>
          </form>
        </div>
        <span class="dialog-footer" slot="footer">
          <el-button type="primary" plain @click="cancelForm" >返回</el-button>
        </span>
        <!-- <div class="demo-drawer__footer insert_data_button_box">
          <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
              <el-button type="primary" plain @click="cancelForm"
                >返回</el-button
              >
            </div>
          </div>
        </div> -->
      </el-dialog>
      <el-dialog
        title="请选择时间段"
        :visible.sync="showTime"
        :modal-append-to-body="false"
        :append-to-body="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="30%"
        :before-close="handleClose"
      >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="开始时间:" prop="startTime">
            <el-date-picker
              size="small"
              clearable
              v-model="ruleForm.startTime"
              value-format="timestamp"
              type="datetime"
              placeholder="选择开始时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="endTime">
            <el-date-picker
              size="small"
              clearable
              v-model="ruleForm.endTime"
              value-format="timestamp"
              type="datetime"
              placeholder="选择结束时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cencelExport" size="small">取 消</el-button>
          <el-button type="primary" @click="saveExport" size="small"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import DailyPatrol from "@/components/DailyPatrol";
export default {
  name: "",
  components: { DailyPatrol },
  props: {},
  data() {
    return {
      dialog: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      selectDate: [],
      // 请求数据
      requestParam: {
        schoolId: this.$store.state.schoolId,
        pageNum: 1,
        pageSize: 20,
        supervisorsStatus: "", // 巡查状态
        startTime: "",
        endTime: "",
        supervisorsId: "",
        actualerId: "",
        regionalPatrolId: "",
        dailyTaskId: ""
      },
      // 部门负责人
      departmentHead: [],
      testUserInfo: {
        userId: ""
      },
      testUserInfo1: {
        userId: ""
      },
      allTask: [],
      allRegion: [],
      // 巡查记录列表
      dailyPatrolRecordList: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },
      // 巡查记录详情
      dailyPatrolRecordDetails: {
        regionalPatrolSite: "",
        userName: "",
        startPatrolTime: 0,
        endPatrolTime: 0,
        actualPatrolTime: 0,
        supervisorsStatus: 0,
        patrolRecordChecksList: [],
        takePhotosRetained: "",
        searchPositioning: "",
        patrolNote: ""
      },
      showTime: false,
      ruleForm: {
        startTime: "", //开始时间
        endTime: "", //结束时间
        schoolId: this.$store.state.schoolId
      },
      loadingType: "",
      rules: {
        startTime: [
          {
            type: "date",
            required: true,
            message: " ",
            trigger: "change"
          }
        ],
        endTime: [
          {
            type: "date",
            required: true,
            message: " ",
            trigger: "change"
          }
        ]
      },
      tableLoading:false
    };
  },
  watch: {},
  computed: {},
  methods: {
    cancelForm() {
      this.dialog = false;
      clearTimeout(this.timer);
    },
    handleCurrentChange(val) {
      this.requestParam.pageNum = val;
      this.dailyPatrolRecord();
      console.log(`当前页: ${val}`);
    },
    handleChange(val) {
      // console.log(val)
    },
    // 选择时间
    selDate() {
      if (this.selectDate) {
        this.requestParam.startTime = parseInt(this.selectDate[0] / 1000);
        this.requestParam.endTime = parseInt(this.selectDate[1] / 1000);
      } else {
        this.requestParam.startTime = "";
        this.requestParam.endTime = "";
      }
    },

    // 选择负责人(新增任务时使用)
    selectDepartmentHead(data) {
      // console.log(this.testUserInfo)
      // console.log(data)
      // console.log(node)
      // var newData = this.$refs.departmentHeadSelect.getCheckedNodes()
      // console.log(newData)
      if (data.length > 0) {
        let value = this.$refs.departmentHeadSelect.panel.getNodeByValue(
          this.testUserInfo.userId
        ).data.thisId;
        // console.log(value)
        // console.log(newData[0].data.thisId);
        this.requestParam.supervisorsId = value;
      } else {
        this.requestParam.supervisorsId = "";
      }
      // console.log(this.requestParam.userId)
      // this.requestParam.userId = newData[0].data.thisId
    },
    selectDepartmentHead1(data) {
      // console.log(this.testUserInfo)
      // console.log(data)
      // console.log(node)
      // var newData = this.$refs.departmentHeadSelect.getCheckedNodes()
      // console.log(newData)
      if (data.length > 0) {
        let value = this.$refs.departmentHeadSelect1.panel.getNodeByValue(
          this.testUserInfo1.userId
        ).data.thisId;
        // console.log(value)
        // console.log(newData[0].data.thisId);
        this.requestParam.actualerId = value;
      } else {
        this.requestParam.actualerId = "";
      }
      // console.log(this.requestParam.userId)
      // this.requestParam.userId = newData[0].data.thisId
    },
    // 获取部门及负责人
    async getDepartmentHead() {
      var _this = this;
      var paramData = {
        schoolId: this.requestParam.schoolId
      };
      let res = await this.$Http.getDepartmentHead(paramData, true);
      if (res.code == 200) {
        // this.departmentHead = res.data
        _this.selectedPersonList = [];
        var departmentHeadList = [];
        for (var keyOne in res.data) {
          var thisUserList = [];
          for (var keyTwo in res.data[keyOne].dlist) {
            // 负责人默认选择
            if (
              this.requestParam.supervisorsId ==
              res.data[keyOne].dlist[keyTwo].userId
            ) {
              this.testUserInfo.userId = [];
              this.testUserInfo.userId.push(keyOne);
              this.testUserInfo.userId.push(keyOne + "-" + keyTwo);
            }

            if (
              this.requestParam.actualerId ==
              res.data[keyOne].dlist[keyTwo].userId
            ) {
              this.testUserInfo1.userId = [];
              this.testUserInfo1.userId.push(keyOne);
              this.testUserInfo1.userId.push(keyOne + "-" + keyTwo);
            }

            // 巡查人员默认选择
            if (
              this.requestParam.dailyTaskTimeStatus == 1 &&
              this.requestParam.timeQuantumList.length >= 1
            ) {
              var selectedUserInfo = Object.assign(
                {},
                this.requestParam.timeQuantumList[0]
              );
              var selectedUserList = selectedUserInfo.userIdArray
                ? selectedUserInfo.userIdArray.split(",")
                : [];
              selectedUserList.forEach((element) => {
                if (element == res.data[keyOne].dlist[keyTwo].userId) {
                  var personUserGroup = [];
                  personUserGroup.push(keyOne);
                  personUserGroup.push(keyOne + "-" + keyTwo);
                  _this.selectedPersonList.push(personUserGroup);
                }
              });
            } else if (
              this.requestParam.dailyTaskTimeStatus == 0 &&
              this.requestParam.timeQuantumList.length >= 1
            ) {
              for (var i = 0; this.inspectionPeriod.length > i; i++) {
                var selectedUserList = this.inspectionPeriod[i].userIdArray
                  ? this.inspectionPeriod[i].userIdArray.split(",")
                  : [];
                selectedUserList.forEach((element) => {
                  if (element == res.data[keyOne].dlist[keyTwo].userId) {
                    var personUserGroup = [];
                    personUserGroup.push(keyOne);
                    personUserGroup.push(keyOne + "-" + keyTwo);
                    this.inspectionPeriod[i].userIdString.push(personUserGroup);
                  }
                });
              }
            }

            var newThisData = {
              value: keyOne + "-" + keyTwo,
              label: res.data[keyOne].dlist[keyTwo].userName,
              thisId: res.data[keyOne].dlist[keyTwo].userId,
              thisLevel: 2
            };
            thisUserList.push(newThisData);
          }

          departmentHeadList[keyOne] = {
            value: keyOne,
            label: res.data[keyOne].departmentName,
            thisId: res.data[keyOne].departmentId,
            thisLevel: 1,
            children: thisUserList
          };
        }
        this.departmentHead = departmentHeadList;
        // console.log(this.inspectionPeriod)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    // 导出今日巡查任务详情
    async exportPatrolTaskDetails() {
      // var requestData = {
      //   schoolId: this.$store.state.schoolId
      // };
      let req = {
        schoolId: this.requestParam.schoolId,
        supervisorsStatus: this.requestParam.supervisorsStatus, // 巡查状态
        startTime: this.requestParam.startTime,
        endTime: this.requestParam.endTime,
        supervisorsId: this.requestParam.supervisorsId,
        actualerId: this.requestParam.actualerId,
        regionalPatrolId: this.requestParam.regionalPatrolId,
        dailyTaskId: this.requestParam.dailyTaskId
      };
      this.$Common.exportData(req, "exportPatrolTaskDetails", "巡查任务详情", false);
    },
    // 导出今日人员完成情况
    async exportPatrolUserLog() {
      // var requestData = {
      //   schoolId: this.$store.state.schoolId
      // };
      let req = {
        schoolId: this.requestParam.schoolId,
        // supervisorsStatus: this.requestParam.supervisorsStatus, // 巡查状态
        startTime: this.requestParam.startTime,
        endTime: this.requestParam.endTime,
        supervisorsId: this.requestParam.supervisorsId,
        actualerId: this.requestParam.actualerId,
        regionalPatrolId: this.requestParam.regionalPatrolId,
        dailyTaskId: this.requestParam.dailyTaskId
      };
      this.$Common.exportData(req, "exportPatrolUserLog", "人员完成情况", false);
    },
    // 导出巡查任务详情
    exportTaskDetails() {
      this.loadingType = "time";
      this.showTime = true;
    },
    // 导出人员完成情况
    exportUserLog() {
      this.loadingType = "user";
      this.showTime = true;
    },
    // 取消导出
    cencelExport() {
      this.showTime = false;
      this.refearshData();
    },
    // 确定导出
    saveExport() {
      let self = this;
      self.$refs.ruleForm.validate((valid) => {
        if (valid) {
          self.exportTask();
        } else {
          return false;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.showTime = false;
      this.refearshData();
    },
    refearshData() {
      this.ruleForm = {
        startTime: "", //开始时间
        endTime: "", //结束时间
        schoolId: this.$store.state.schoolId
      };
      this.$refs.ruleForm.resetFields();
    },
    // 日常巡查记录搜索
    dailyPatrolRecordSearch() {
      this.requestParam.pageNum = 1;
      this.dailyPatrolRecord();
    },

    // 导出今日巡查任务详情
    async exportTask() {
      let req = Object.assign({}, this.ruleForm);
      req.startTime = parseInt(req.startTime) / 1000;
      req.endTime = parseInt(req.endTime) / 1000;
      const loading = this.$loading({
        lock: true,
        text: "导出数据中,请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let res;
      let fileNameTemp;
      if (this.loadingType == "time") {
        // 导出巡查任务详情
        res = await this.$Http.exportTaskDetails(req);
        fileNameTemp = "巡查任务详情";
      } else {
        // 导出人员完成情况
        res = await this.$Http.exportUserLog(req);
        fileNameTemp = "人员完成情况";
      }
      // if (res.data == "") {
      //   this.$message({
      //     type: "warning",
      //     message: "暂无数据", 
      //     duration: 1000 
      //   });
      //   return false;
      // }

      this.showTime = false;
      this.refearshData();
      loading.close();
      const content = res;
      const blob = new Blob([content]);
      // console.log(blob)
      const fileName =
        fileNameTemp +
        this.$Common.dateFormatDateTwo(Date.parse(new Date()) / 1000) +
        ".xls"; // 导出文件名
      // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
      // IE10以上支持blob但是依然不支持download
      if ("download" in document.createElement("a")) {
        // 支持a标签download的浏览器
        const link = document.createElement("a"); // 创建a标签
        link.download = fileName; // a标签添加属性
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click(); // 执行下载
        URL.revokeObjectURL(link.href); // 释放url
        document.body.removeChild(link); // 释放标签
      } else {
        // 其他浏览器
        navigator.msSaveBlob(blob, fileName);
      }
    },
    // 日常巡查记录详情
    async getDailyPatrolRecordDetails(id) {
      var paramData = {
        id: id
      };
      let res = await this.$Http.dailyPatrolRecordDetails(paramData);
      // console.log(res.data)
      if (res.code == 200) {
        this.dailyPatrolRecordDetails = res.data;
        this.dailyPatrolRecordDetails.startPatrolTime = this.$Common.dateFormatDateTwo(
          this.dailyPatrolRecordDetails.startPatrolTime
        );
        this.dailyPatrolRecordDetails.endPatrolTime = this.$Common.dateFormatDateTwo(
          this.dailyPatrolRecordDetails.endPatrolTime
        );
        this.dailyPatrolRecordDetails.actualPatrolTime =
          this.dailyPatrolRecordDetails.actualPatrolTime <= 0
            ? "暂未巡查"
            : this.$Common.dateFormatDateTwo(
                this.dailyPatrolRecordDetails.actualPatrolTime
              );
        this.dailyPatrolRecordDetails.regionalPatrolSite = this.dailyPatrolRecordDetails.regionalPatrol.regionalPatrolSite;
        this.dailyPatrolRecordDetails.userName = this.dailyPatrolRecordDetails.user.userName;
        this.dialog = true;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 日常巡查记录
    async dailyPatrolRecord() {
      this.tableLoading = true
      let req = Object.assign({}, this.requestParam);
      let res = await this.$Http.dailyPatrolRecord(req);
      this.tableLoading = false
      if (res.code == 200) {
        this.dailyPatrolRecordList = res.data;
      } else if (res.code == 101) {
        this.dailyPatrolRecordList.list = [];
        this.dailyPatrolRecordList.total = 0;
      } else {
        this.dailyPatrolRecordList.list = [];
        this.dailyPatrolRecordList.total = 0;
        this.$message({
          type: "error",
          message: "列表获取失败"
        });
      }
    },
    // 获取学校所有日常巡查任务
    async getInspectionAllTask() {
      let req = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getInspectionAllTask(req);
      if (res.code == 200) {
        // console.log(res.data)
        this.allTask = res.data;
      } else if (res.code == 101) {
        this.allTask = [];
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取所有巡查区域
    async getAllPatrolRegion() {
      let req = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getAllPatrolRegion(req);
      if (res.code == 200) {
        // console.log(res.data)
        this.allRegion = res.data;
      } else if (res.code == 101) {
        this.allRegion = [];
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  },
  created() {},
  mounted() {
    this.dailyPatrolRecord();
    this.getDepartmentHead();
    this.getInspectionAllTask();
    this.getAllPatrolRegion();
  }
};
</script>
<style lang="scss" scoped>
.select-cascader {
  width: 120px;
  margin-left: 5px;
}
.select-cascader-1 {
  width: 144px;
  margin-left: 2px;
}
.select-date {
  width: 400px;
}
.select-input {
  width: 132px;
  margin-left: 2px;
}
.select-btn {
  margin-left: 2px;
}
.special {
  color: #fc4747;
}

.patrolDialog{
  .col-sm-10,.form-control{
    font-size:12px !important;
    margin:0;
  }
  .control-label{
    font-size:13px;
    width:120px !important;
    padding:7px 0 0;
  }
  .insert_data_form{
    height:auto !important;
  }
  
  .statusBox{
    color:#67c23a;background:#f0f9eb;border:1px solid #e1f3d8;padding:5px 10px;border-radius:5px;font-size:12px;
  }
  .statusBoxDanger{
    color:#f56c6c;background:#fef0f0;border:1px solid #fde2e2;padding:5px 10px;border-radius:5px;font-size:12px;
  }
}
</style>
